// TODO: Добавить тип из новой ручки в CD-203174
export function mkBreadcrumbs() {
  return [
    {
      title: 'Недвижимость в Санкт-Петербурге',
      url: 'https://spb.cian.ru/',
    },
    {
      title: 'Акции и скидки',
      url: 'https://spb.cian.ru/akcii-i-skidki/',
    },
    {
      title: 'Ипотечные предложения',
      url: null,
    },
  ];
}
